import { Component, inject } from '@angular/core';
import {ButtonConfig, buttonsStaticConfig, NotificationEnum, NotificationService} from '../../../global';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BehaviorSubject, tap} from 'rxjs';
import { DataImportDialogConfig } from '../../../global/entities/data-import.entity';
import { DialogContainerComponent } from '../../components/dialog-container/dialog-container.component';
import { DataImportContainerComponent } from '../../containers/data-import/data-import.container';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'slm-data-import-dialog',
    templateUrl: './data-import.dialog.html',
    imports: [DialogContainerComponent, DataImportContainerComponent, AsyncPipe]
})
export class DataImportDialog {
  private readonly dialogRef = inject<MatDialogRef<DataImportDialog>>(MatDialogRef);
  private readonly notification = inject(NotificationService);
  data = inject<DataImportDialogConfig>(MAT_DIALOG_DATA);

  public readonly buttons: Array<ButtonConfig> = [
    buttonsStaticConfig.cancel,
    {
      ...buttonsStaticConfig.import,
      buttonStyle: 'primary',
      icon: null
    }
  ];

  private file: File = null;
  public readonly notification$ = new BehaviorSubject<{ message: string; isInnerHtml: boolean; type: NotificationEnum }>({
    message: 'MESSAGE.IMPORT_MESSAGE',
    type: NotificationEnum.WARNING,
    isInnerHtml: false
  });

  public buttonEvent(event: string) {
    if (event === buttonsStaticConfig.cancel.action) {
      this.dialogRef.close();
      return;
    }
    if (this.buttons[1].isLoading) {
      return;
    }
    if (!this.file) {
      this.notification.notify('MESSAGE.FILE_SELECTION_REQUIRED', NotificationEnum.ERROR);
      return;
    }
    this.dialogRef.disableClose = true;
    this.buttons[1].isLoading = true;
    this.data.save(this.file)
      .pipe(tap(() => {
        this.notification.notify('MESSAGE.UPLOAD_SUCCESS');
        this.dialogRef.close(true);
      }))
      .subscribe({
        error: (error) => {
          (error?.error?.message || error?.message) && this.notification$.next({
            type: NotificationEnum.ERROR,
            message: error?.error?.message || error?.message,
            isInnerHtml: true
          });
          this.buttons[1].isLoading = this.dialogRef.disableClose = false;
        },
        complete: () => this.buttons[1].isLoading = this.dialogRef.disableClose = false
      });
  }

  public setSelectedFile(file: File) {
    this.file = file;
  }
}
